import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Logo } from '@shared/ui';

interface EmailConfirmLayoutProps {
  children: ReactNode;
}

export function EmailConfirmLayout({ children }: EmailConfirmLayoutProps) {
  const { t } = useTranslation();
  return (
    <div className="flex h-dvh w-full flex-col overflow-y-auto bg-base px-5 py-8 sm:px-8 md:px-12 md:py-10">
      {/* Лого всегда целиком (142 px). До 390 px подписи рядом нет места даже в две строки — её нет совсем:
          что это за страница, говорит заголовок; прежде сжималось лого — «Lomo…» (R2-02). */}
      <div className="mb-8 flex items-center justify-between gap-4">
        <Logo className="shrink-0" />
        <div className="min-w-0 text-right text-[12px] font-medium uppercase tracking-[0.16em] text-muted max-[389.98px]:hidden">
          {t('auth.confirmEmail.kicker')}
        </div>
      </div>
      <div className="flex flex-1 items-center justify-center">{children}</div>
      <div className="text-[12px] font-medium uppercase tracking-[0.14em] text-muted-2">
        {t('auth.versionSecure')}
      </div>
    </div>
  );
}
